"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGlDraw = require("react-map-gl-draw");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _center = _interopRequireDefault(require("@turf/center"));

var _circle = _interopRequireDefault(require("@turf/circle"));

var _distance = _interopRequireDefault(require("@turf/distance"));

var _helpers = require("@turf/helpers");

var _geojson = _interopRequireDefault(require("../geojson"));

var _geojsonEditor = require("../geojson-editor");

var _propTypes2 = require("../propTypes");

var _customEditingMode = _interopRequireDefault(require("./custom-editing-mode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GeoJsonEditor = function GeoJsonEditor(_ref) {
  var features = _ref.features,
      featureStyle = _ref.featureStyle,
      editMode = _ref.editMode,
      _onSelect = _ref.onSelect,
      _onUpdate = _ref.onUpdate;
  var style = (0, _react.useMemo)(function () {
    var fillColor = featureStyle.fillColor,
        fillOpacity = featureStyle.fillOpacity,
        strokeColor = featureStyle.strokeColor,
        strokeWeight = featureStyle.strokeWeight,
        strokeOpacity = featureStyle.strokeOpacity;
    return {
      fill: fillColor,
      fillOpacity: fillOpacity,
      stroke: strokeColor,
      strokeWidth: strokeWeight,
      strokeOpacity: strokeOpacity
    };
  }, [featureStyle]);
  var mode = (0, _react.useMemo)(function () {
    switch (editMode) {
      case _geojsonEditor.editModes.drawCircle:
        {
          return new _reactMapGlDraw.DrawCircleFromCenterMode();
        }

      case _geojsonEditor.editModes.drawPolygon:
        {
          return new _reactMapGlDraw.DrawPolygonMode();
        }

      case _geojsonEditor.editModes.edit:
      default:
        {
          return new _customEditingMode["default"]();
        }
    }
  }, [editMode]);
  var mappedFeatures = (0, _react.useMemo)(function () {
    // map all circles to polygon (needed by react-map-gl-draw)
    var featureToCircle = function featureToCircle(feature) {
      var _feature$geometry;

      if (((_feature$geometry = feature.geometry) === null || _feature$geometry === void 0 ? void 0 : _feature$geometry.type) === 'Point' && feature.properties.radius) {
        return (0, _circle["default"])(feature.geometry.coordinates, feature.properties.radius, {
          units: 'meters',
          properties: _objectSpread(_objectSpread({}, feature.properties), {}, {
            shape: 'Circle'
          })
        });
      }

      return feature;
    };

    if (features.type === 'FeatureCollection') {
      return (0, _helpers.featureCollection)(features.features.map(featureToCircle));
    }

    if (features.type === 'Feature') {
      return (0, _helpers.featureCollection)([featureToCircle(features)]);
    }

    return (0, _helpers.featureCollection)(features.map(featureToCircle));
  }, [features]);
  return /*#__PURE__*/_react["default"].createElement(_reactMapGlDraw.Editor, {
    mode: mode,
    features: mappedFeatures,
    editHandleShape: "circle",
    featureStyle: style,
    onSelect: function onSelect(_ref2) {
      var selectedFeature = _ref2.selectedFeature,
          selectedFeatureIndex = _ref2.selectedFeatureIndex;

      _onSelect({
        selectedFeature: selectedFeature,
        selectedFeatureIndex: selectedFeatureIndex
      });
    },
    onUpdate: function onUpdate(_ref3) {
      var data = _ref3.data;

      // convert all features back to nicplace format (point + radius) from polygon
      _onUpdate((0, _helpers.featureCollection)(data.map(function (feature) {
        var _feature$geometry2;

        if (feature.properties.shape === 'Circle' && ((_feature$geometry2 = feature.geometry) === null || _feature$geometry2 === void 0 ? void 0 : _feature$geometry2.type) === 'Polygon') {
          var polygonCenter = (0, _center["default"])(feature);
          var radius = (0, _distance["default"])(polygonCenter.geometry.coordinates, feature.geometry.coordinates[0][0], {
            units: 'meters'
          });
          return (0, _helpers.point)(polygonCenter.geometry.coordinates, _objectSpread(_objectSpread({}, feature.properties), {}, {
            radius: radius
          }));
        }

        return feature;
      })));
    }
  });
};

GeoJsonEditor.propTypes = {
  features: _propTypes["default"].oneOfType([(0, _propTypes2.FeatureCollectionShape)(), _propTypes["default"].arrayOf((0, _propTypes2.FeatureShape)()), (0, _propTypes2.FeatureShape)()]),
  featureStyle: _geojson["default"].propTypes.featureStyle,
  editMode: _propTypes["default"].oneOf(['EDIT', 'DRAW_CIRCLE', 'DRAW_POLYGON']),
  onSelect: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func
};

var noop = function noop() {};

GeoJsonEditor.defaultProps = {
  features: {
    type: 'FeatureCollection',
    features: []
  },
  featureStyle: _geojson["default"].defaultProps.featureStyle,
  editMode: null,
  onSelect: noop,
  onUpdate: noop
};
var _default = GeoJsonEditor;
exports["default"] = _default;